import { render } from "./Countries.vue?vue&type=template&id=05ee0a5e&scoped=true"
import script from "./Countries.vue?vue&type=script&lang=js"
export * from "./Countries.vue?vue&type=script&lang=js"

import "./Countries.vue?vue&type=style&index=0&id=05ee0a5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-05ee0a5e"

export default script